// anti-snoop.js — light deterrent against casual right-click + view-source.
//
// Goals:
//   - Block default context menu (right-click) for non-admins
//   - Block Ctrl-U (view-source) and Ctrl-S (save page)
//   - Leave F12 / Ctrl-Shift-I (DevTools) alone — blocking these breaks
//     accessibility tools, password managers, and is trivially bypassed
//   - Admin role always sees normal browser behavior
//   - Inputs/textareas keep normal context menu so users can paste
//
// Honest scope: deterrent only. DevTools, curl, or disabling JS still
// gives full source access. Purpose is to suppress accidental discovery.

let _isAdmin = false;

export function setAdminBypass(admin) { _isAdmin = !!admin; }

function shouldBlock() { return !_isAdmin; }

function isInputTarget(node) {
  if (!node) return false;
  const tag = (node.tagName || '').toUpperCase();
  return tag === 'INPUT' || tag === 'TEXTAREA' || node.isContentEditable;
}

window.addEventListener('contextmenu', function (e) {
  if (shouldBlock() && !isInputTarget(e.target)) e.preventDefault();
}, true);

window.addEventListener('keydown', function (e) {
  if (!shouldBlock()) return;
  const ctrl = e.ctrlKey || e.metaKey;
  if (ctrl && (e.key === 'u' || e.key === 'U')) {
    e.preventDefault(); e.stopPropagation();
  }
  if (ctrl && (e.key === 's' || e.key === 'S') && !isInputTarget(document.activeElement)) {
    e.preventDefault(); e.stopPropagation();
  }
}, true);

window.gdbsAntiSnoopEnabled = () => shouldBlock();
